const AUDIO_CATEGORIES = [
    'Receiver',
    'Amplifier',
    'Turntable',
    'Cassette Deck',
    'Reel-to-Reel',
    'CD Player',
    'Speakers',
    'Tuner',
    'Equalizer',
    'Headphones',
    'Accessory',
    'Other',
];
const AUDIO_BRANDS = [
    'Bang & Olufsen',
    'Crown',
    'Denon',
    'Dynaco',
    'Fisher',
    'Harman Kardon',
    'JBL',
    'Kenwood',
    'Klipsch',
    'Luxman',
    'Marantz',
    'McIntosh',
    'NAD',
    'Nakamichi',
    'Nordmende',
    'Onkyo',
    'Pioneer',
    'Quad',
    'Revox',
    'Sansui',
    'Sony',
    'Tandberg',
    'Technics',
    'Thorens',
    'Yamaha',
    'Other',
];
const AUDIO_CATEGORY_BRANDS = {
    Turntable: ['Technics', 'Thorens', 'Pioneer', 'Denon', 'Sony', 'Yamaha', 'Bang & Olufsen', 'Other'],
    Speakers: ['JBL', 'Klipsch', 'Pioneer', 'Sansui', 'Quad', 'Bang & Olufsen', 'Other'],
    'Cassette Deck': ['Nakamichi', 'Sony', 'Pioneer', 'Denon', 'Yamaha', 'Technics', 'Other'],
    'Reel-to-Reel': ['Revox', 'Tandberg', 'Sony', 'Pioneer', 'Technics', 'Crown', 'Other'],
};
const AUDIO_BRAND_MODELS = {
    Pioneer: ['SX-1250', 'SX-1050', 'SX-980', 'SX-780', 'SA-9500', 'PL-530', 'CT-F1250', 'HPM-100'],
    Marantz: ['2270', '2245', '2230', '1060', '4300', '6300', 'Model 9'],
    Sansui: ['AU-717', 'AU-919', 'G-9000', 'TU-717', 'QRX-9001'],
    Technics: ['SL-1200', 'SL-1210', 'SA-1000', 'RS-1500', 'SB-7000'],
    Sony: ['STR-6800SD', 'TC-756-2', 'PS-X800', 'TA-N86B'],
    McIntosh: ['MC275', 'MC240', 'C22', 'MR71', 'MC2105'],
    Nakamichi: ['Dragon', '1000', '700', '680ZX', 'CR-7A'],
    Yamaha: ['CR-2020', 'CR-1020', 'NS-1000', 'A-1', 'CT-7000'],
    JBL: ['L100', 'L300', '4311', '4343', 'Paragon'],
    Klipsch: ['Klipschorn', 'La Scala', 'Cornwall', 'Heresy'],
    Thorens: ['TD-124', 'TD-150', 'TD-160', 'TD-126'],
    Revox: ['A77', 'B77', 'A700', 'G36'],
};
const AUDIO_SUBCATEGORIES = {
    Receiver: ['Stereo', 'Quadraphonic', 'Surround'],
    Amplifier: ['Integrated', 'Power', 'Pre-amplifier', 'Tube', 'Solid State'],
    Turntable: ['Belt Drive', 'Direct Drive', 'Idler Drive'],
    'Cassette Deck': ['Single', 'Dual', 'Portable'],
    Speakers: ['Bookshelf', 'Floor Standing', 'Monitor', 'Subwoofer'],
    Headphones: ['Over-Ear', 'On-Ear', 'Electrostatic'],
    Accessory: ['Cartridge', 'Stylus', 'Cable', 'Rack', 'Cleaning Kit'],
};
export const retroAudioVaultType = {
    id: 'retro_audio',
    label: 'Retro Audio / Hi-Fi',
    tagline: 'Catalog your vintage sound systems',
    icon: 'Radio',
    platformLabel: 'Brand',
    categories: AUDIO_CATEGORIES,
    brands: AUDIO_BRANDS,
    brandModels: AUDIO_BRAND_MODELS,
    categoryBrands: AUDIO_CATEGORY_BRANDS,
    subcategories: AUDIO_SUBCATEGORIES,
    conditions: ['mint', 'excellent', 'good', 'fair', 'poor', 'parts'],
    specializedFields: [
        { key: 'watts_per_channel', label: 'Watts/Channel', type: 'text', placeholder: 'e.g. 80W' },
        { key: 'impedance', label: 'Impedance', type: 'text', placeholder: 'e.g. 8 ohms' },
        { key: 'frequency_response', label: 'Frequency Response', type: 'text', placeholder: 'e.g. 20Hz-20kHz' },
        { key: 'drive_type', label: 'Drive Type', type: 'select', options: ['Belt Drive', 'Direct Drive', 'Idler Drive', 'N/A'] },
        { key: 'cartridge_type', label: 'Cartridge Type', type: 'text', placeholder: 'e.g. Shure M44-7' },
        { key: 'tube_type', label: 'Tube Type', type: 'text', placeholder: 'e.g. 12AX7, EL34' },
    ],
    specializedFeatures: {
        capacitor_maps: true,
        tube_tracking: true,
        foam_surround: true,
    },
    aiSystemPrompt: `You are an expert in vintage audio equipment and Hi-Fi systems. Analyze the provided image and identify the equipment. Provide details including: the manufacturer/brand, model name, approximate year of manufacture, category (Receiver, Amplifier, Turntable, Speakers, etc.), condition assessment, and any notable features like tube vs solid state, watts per channel, or special technologies. If you can identify specific components, knobs, VU meters, or modifications, mention those.`,
    maintenanceAlertTypes: [
        'cap_replacement',
        'tube_replacement',
        'foam_surround',
        'belt_replacement',
        'pot_cleaning',
        'custom',
    ],
    fileTypes: ['manual_pdf', 'schematic', 'other'],
    defaultThemes: ['tube_glow', 'vu_meter', 'brushed_aluminum', 'reel_to_reel', 'vinyl_groove'],
};
//# sourceMappingURL=retroAudio.js.map